import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';

import { FormSelect, OptionProps } from '@digital/ui';

import { getAllAreasByDiretoriaOptions } from '../../../../../api/area';
import {
  getAllDepartamentoProAreaIdOptions,
  getAllDepartamentoProDiretoriaIdOptions,
} from '../../../../../api/departamento';
import { getAllDiretoriasOptions } from '../../../../../api/diretoria';
import QuestionarioContextProvider from '../../../../../hooks/useQuestionario';

interface IDadosRequisitanteFieldsProps {
  disabled?: boolean;
}

function DadosRequisitanteFields({ disabled }: IDadosRequisitanteFieldsProps) {
  const {
    statusCodigo,
    diretoriaId,
    setDiretoriaId,
    areaId,
    setAreaId,
    departamentoId,
    setDepartamentoId,
    id,
  } = useContext(QuestionarioContextProvider);
  const [departamentos, setDepartamentos] = useState<OptionProps[]>();
  const [areas, setAreas] = useState<OptionProps[]>();

  useEffect(() => {
    setAreas([{ text: 'N/A', value: 'na' }]);
    setDepartamentos([{ text: 'N/A', value: 'na' }]);

    if (diretoriaId) {
      getAllAreasByDiretoriaOptions(diretoriaId).then(data => {
        let areas = [...data, { text: 'N/A', value: 'na' }];
        setAreas(areas);
      });
      getAllDepartamentoProDiretoriaIdOptions(diretoriaId).then(data => {
        let departamentos = [...data, { text: 'N/A', value: 'na' }];
        setDepartamentos(departamentos);
      });
    }
  }, [diretoriaId]);

  useEffect(() => {
    if (areaId && areaId !== 'na') {
      getAllDepartamentoProAreaIdOptions(areaId).then(data => {
        let departamentos = [...data, { text: 'N/A', value: 'na' }];
        setDepartamentos(departamentos);
      });
    }

    if (diretoriaId) {
      getAllDepartamentoProDiretoriaIdOptions(diretoriaId).then(data => {
        let departamentos = [...data, { text: 'N/A', value: 'na' }];
        setDepartamentos(departamentos);
      });
    }
  }, [areaId]);

  const handleChangeDiretoria = (value: string) => {
    setDiretoriaId(value);
    setAreaId(undefined);
    setDepartamentoId(undefined);
  };

  const handleChangeArea = (value: string) => {
    setAreaId(value);
    setDepartamentoId(undefined);
  };

  return (
    <>
      <FormSelect
        id='mrn-select-diretoria'
        label="Diretoria"
        name="diretoriaId"
        placeholder="Selecione uma opção"
        getOptions={getAllDiretoriasOptions}
        value={diretoriaId}
        onChange={value => handleChangeDiretoria(value)}
        span={4}
        disabled={disabled || statusCodigo !== 1 && id !== null}
        required
        validateSchema={Yup.string().trim().required('Campo requerido.')}
      />
      <FormSelect
        id='mrn-select-area'
        label="Área"
        name="areaId"
        placeholder="Selecione uma opção"
        options={areas}
        span={4}
        value={areaId}
        onChange={value => handleChangeArea(value)}
        allowClear
        disabled={disabled || statusCodigo !== 1 && id !== null}
        required
        validateSchema={Yup.string().trim().required('Campo requerido.')}
      />

      {departamentos && (
        <FormSelect
          id='mrn-select-departamento'
          label="Departamento"
          name="departamentoId"
          placeholder="Selecione uma opção"
          options={departamentos}
          value={departamentoId}
          span={4}
          onChange={value => setDepartamentoId(value)}
          allowClear
          disabled={disabled || statusCodigo !== 1 && id !== null}
          required
          validateSchema={Yup.string().trim().required('Campo requerido.')}
        />
      )}
    </>
  );
}
export default DadosRequisitanteFields;
